import axios, { AxiosResponse } from 'axios';

export class HttpError extends Error {
  constructor(
    public name: string,
    public message: string,
    public status?: number,
    public key?: string,
    public code?: string,
  ) {
    super(message);
    this.name = name;
    this.status = status;
    this.key = key;
    this.code = code;
  }
}

async function httpErrorHandler(error: unknown) {
  if (!axios.isAxiosError(error) || error === null) throw new Error(`Erro desconhecido: ${JSON.stringify(error)}`);

  const response = error.response;

  if (!response) {
    throw new HttpError(
      'Ocorreu um erro',
      'Ocorreu um erro ao processar sua solicitação. Por favor, tente novamente em instantes. Se o problema persistir, entre em contato com o suporte',
    );
  }

  const isUnauthorized = response.status === 403;
  const originalConfig = error.config;

  if (isUnauthorized && originalConfig) return;

  const title = response.data.title;
  const description = response.data.message;
  const status = response.status;
  const key = response.data.key;
  const code = response.data.code;
  throw new HttpError(title, description, status, key, code);
}

export function responseHandler(response: AxiosResponse) {
  return response;
}

export function responseErrorHandler(error: unknown) {
  return httpErrorHandler(error);
}
